module.exports = __webpack_public_path__ + "img/selected6-min.249e6a2f.png";